import React from "react";
import get from "lodash/get";
import ShareModal from "../../parts/modals/share";

import BaselineVolumeRelativeIntensity from "./types/baseline-volume-relative-intensity";
import CompetitionHistory from "./types/competition-history";
import NumberOfLifts from "./types/number-of-lifts";
import OverunderBaseline from "./types/over-under-baseline";
import RawEquippedVolumeSplit from "./types/raw-equipped-volume-split";
import RecordTable from "./types/record-table";
import VolumeIntensity from "./types/volume-intensity";
import CoreAccessoryVolumeSplit from "./types/core-accessory-volume-split";
import VolumeSplitCoreLift from "./types/volume-split-core-lift";
import Workout from "./types/workout";
import RepMaxEstimator from "./types/rep-max-estimator";
import RpeTable from "./types/rpe-table";
import Custom from "./types/custom";

const TYPES = {
  "baseline-volume-relative-intensity": BaselineVolumeRelativeIntensity,
  "competition-history": CompetitionHistory,
  "number-of-lifts": NumberOfLifts,
  "over-under-baseline": OverunderBaseline,
  "raw-equipped-volume-split": RawEquippedVolumeSplit,
  "record-table": RecordTable,
  "volume-intensity": VolumeIntensity,
  "core-accessory-volume-split": CoreAccessoryVolumeSplit,
  "volume-split-core-lift": VolumeSplitCoreLift,
  workout: Workout,
  "rep-max-estimator": RepMaxEstimator,
  "rpe-table": RpeTable,
  custom: Custom,
};

const Share = (app) => {
  app.get("/share/:snapshot", async ({ req, res, locals, load }, next) => {
    const snapshot = await load("snapshot", { snapshot: req.params.snapshot });
    if (!snapshot) return;
    const Type = TYPES[snapshot.type];
    if (!Type) return;

    const shareType =
      {
        "competition-history": "Competition Report",
        workout: "Workout",
      }[snapshot.type] || "Metrics";

    locals.title += "My " + shareType;

    const modal = get(req.query, "modal", {});
    locals.modal = {
      share: <ShareModal />,
    }[modal.type];

    res.body = <Type />;
  });
};

export default Share;
